import React, { useState, useEffect } from 'react';
import moment, { Moment } from 'moment';
import { PAUSED, PLAYING } from 'state';

type CountdownProps = {
  runAtIso: string; // e.g. "2025-07-15T14:01:02.345Z"
  status: number;
};

export const CountdownTimer: React.FC<CountdownProps> = ({
  runAtIso,
  status,
}) => {
  // parse incoming ISO → a Moment (or Date)
  const runAt: Moment = moment.utc(runAtIso);
  const [secondsLeft, setSecondsLeft] = useState<number>(
    Math.max(0, runAt.diff(moment.utc(), 'seconds'))
  );

  useEffect(() => {
    // tick once a second
    const id = window.setInterval(() => {
      const secs = runAt.diff(moment.utc(), 'seconds');
      setSecondsLeft(secs > 0 ? secs : 0);
    }, 1000);
    return () => clearInterval(id);
  }, [runAtIso]);

  // format as mm:ss or just raw seconds
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;

  const style: React.CSSProperties = {
    color: secondsLeft <= 10 ? 'red' : undefined,
    fontWeight: secondsLeft <= 10 ? 'bold' : undefined,
  };

  if (status === PAUSED) {
    return <span>PAUSED</span>;
  }

  return (
    <span style={style}>
      {minutes}:{seconds.toString().padStart(2, '0')}
    </span>
  );
};
